import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route, withRouter } from 'react-router-dom';
import App from './App';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

const AppWithRouter = withRouter(App)

ReactDOM.render(
    <Router>
        <Switch>
            <Route path="/">
                <AppWithRouter/>
            </Route>
        </Switch>
    </Router>,
    document.getElementById('root')
);
